export default {"src":"/_next/static/media/validate-sitter.55fcf4af.svg","height":261,"width":267,"blurWidth":0,"blurHeight":0};